import { MilestoneType } from './milestoneUpsellStorage';

export type MilestoneUpsellVariant = 'A' | 'B' | 'C';

/**
 * Default creative until the MEME experiment (FeaturesApi) is wired.
 * A = streak identity claim, B = module momentum, C = commitment recall.
 */
export const getMilestoneUpsellVariant = (milestone: MilestoneType): MilestoneUpsellVariant =>
  milestone === 'streak_7' ? 'A' : 'B';
